import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-caso',
  templateUrl: './detail-caso.component.html',
  styleUrls: ['./detail-caso.component.scss']
})
export class DetailCasoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
